<template>
  <div class="details-page">
    <!-- <OverlayLoad :show="loading"></OverlayLoad> -->
    <div class="good height-100">
      <!-- 轮播图区域 -->
      <div class="banner-section">
        <van-swipe class="banner-swipe" :autoplay="10000" indicator-color="white">
          <van-swipe-item v-for="(item, index) in bannerList" :key="index">
            <van-image :src="item" alt="" class="banner-image" fit="cover" />
          </van-swipe-item>
        </van-swipe>
        <price-compare-bar :visible="showPriceCompareFloatBar" />
      </div>

      <!-- 商品信息区域 -->
      <div class="info-section">
        <!-- 价格区域 -->
        <div class="price-section">
          <!-- 根据后端返回的 isShowPrice 决定是否显示价格（次数卡不显示） -->
          <div class="price" v-if="detail?.isShowPrice !== false">
            <div class="price-main-row">
              <span class="price-value">{{ selectPrice }}</span>
              <span class="price-unit">{{ selectPriceUnit }}</span>
              <template v-if="showPriceCompareDetail">
                <span class="market-price">参考价{{ currentMarketPrice }}{{ selectPriceUnit }}</span>
                <span class="save-amount">立省{{ formatSaveAmount(currentSaveAmount) }}{{ selectPriceUnit }}</span>
              </template>
            </div>
          </div>
          <div class="title-tag" v-if="getTitleTag()" :style="{ background: getTitleTag().colorCode }">
            {{ getTitleTag().name }}
          </div>
        </div>

        <!-- 商品名称 -->
        <div class="product-name">
          <span class="name">{{ detail?.productName }} <span v-if="chousetype">{{ chousetype }}</span></span>
        </div>

        <!-- 标签列表 -->
        <div class="tag-list">
          <span class="tag-item" v-for="(val, index) in getTagList()" :key="index">{{ val.name }}</span>
        </div>

        <!-- 价格保护：京东编码（仅价格保护活动商品列表进入时展示） -->
        <div v-if="hasJdPriceCompare" class="jd-sku-bar">
          <div class="jd-sku-bar__label" @click.stop="openPriceCompareRule">
            <van-icon name="shield-o" class="jd-sku-bar__shield" />
            <span>价格保护</span>
            <span class="jd-sku-bar__help">说明</span>
          </div>
          <div class="jd-sku-bar__actions">
            <span class="jd-sku-bar__meta-label">京东编码</span>
            <span class="jd-sku-bar__code">{{ currentJdSkuCode }}</span>
            <span class="jd-sku-bar__copy" @click.stop="copyJdSkuCode">复制</span>
          </div>
        </div>
      </div>

      <price-compare-rule-dialog
        :visible.sync="showPriceCompareRuleDialog"
      />

      <!-- 规格选择区域 -->
      <div class="spec-section">
        <div v-if="detail?.brandName" class="spec-item" @click="handleProductList">
          <div class="spec-label">
            <div class="header-line"></div>
            <span class="label-text">品牌</span>
          </div>
          <div class="spec-content">
            <span class="spec-text">{{ detail?.brandName }}</span>
            <van-icon name="arrow" color="#c8c8c8" size="14px" />
          </div>
        </div>
        <div class="spec-item" @click="specPopupOpen">
          <div class="spec-label">
            <div class="header-line"></div>
            <span class="label-text">选择</span>
          </div>
          <div class="spec-content">
            <span class="spec-text">{{ selectGoods || '请选择规格' }}</span>
            <van-icon name="arrow" color="#c8c8c8" size="14px" />
          </div>
        </div>
      </div>

      <!-- 商品详情区域 -->
      <div class="detail-section">
        <div class="section-header">
          <div class="header-line"></div>
          <span class="header-text">商品详情</span>
        </div>

        <!-- 商品描述 -->
        <div class="description" v-html="sanitizedDescription"></div>
        
        <!-- 商品图片列表 -->
        <div class="image-list">
          <van-image 
            v-for="(item, index) in goodsDetailImgList" 
            :key="index" 
            :src="item"
            class="detail-image"
          />
        </div>

      </div>

      <!-- 底部操作栏 -->
      <van-goods-action>
        <van-goods-action-icon icon="cart-o" text="购物车" @click="goCar" />
        <van-goods-action-button type="warning" :disabled="cantBuy" :text="textCar"
          v-if="showAddCard && productType !== '0'" @click="() => specPopupOpen('addCart')" />
        <van-goods-action-button type="danger" :disabled="cantBuy" :text="textBuy"
          @click="() => specPopupOpen('buyNow')" />
      </van-goods-action>
    </div>
    <SpecPopup v-if="productDetaiLoad && detail" :goodsType="detail.category1Id && detail.category1Id == '5' ? 'cake' : 'normal'"
      ref="specPopupRef" :list="specsLsit" :current-address="currentAddressInfo" :product-type="productType"
      :venue-list="detail?.venueList" :current-distribution="detail.distributionRuleId" :query-form="detailform"
      :channel-type="2" @addressChange="handleSpecPopupAddressChange" @specChange="handleSpecChange"
      @ticketChange="handleTicketChange" @submit="handleSpecSubmit"></SpecPopup>
  </div>
</template>

<script>
// import { Dialog, Toast } from "vant";
import DetailsSpecItem from "./DetailsSpecItem.vue";
import DetaillNow from "../../components/goods/DetaillNow.vue";
import SelectAddress from "../../components/goods/SelectAddress.vue";
import ShopAddress from "../../components/goods/ShopAddress.vue";
import SendType from "../../components/goods/SendType.vue";
import SpecPopup from "../../components/SpecPopup/index.vue";
import OverlayLoad from "../../components/SpecPopup/OverlayLoad.vue";
import PriceCompareBar from "../../components/goods/PriceCompareBar.vue";
import PriceCompareRuleDialog from "../../components/goods/PriceCompareRuleDialog.vue";
import { goMyCart, getGoodsDetail, submitBuyGoodsInfo, queryDistributionRules, goBrandProductList } from "./index.action";
import Utils from "../../utils";
import { sanitizeHtml } from "@/utils/sanitize";
//import { sendSelectTypeOptions } from "../../config/options";

export default {
  name: "Details",
  props: {},
  data() {
    return {
      bannerList: [], // banner图
      goodsDetailImgList: [], // 商品详情数组
      specsLsit: [], // 可选规格列表
      loading: false,
      productDetaiLoad: false, // 详情信息,是否加载完成
      detail: null,
      bannerHeight: 0,
      //商品规格
      show: false,
      selectGoods: "", // 展示所选规格的商品
      sendTypeStr: "", // 展示的配送信息
      // sendTypeAddress:'',
      address: "",
      detailform: {
        cardId: "",
        cityCode: "",
        brandId: "",
        productId: ""
      },
      cantBuy: true,// 不能买和加入购物车
      textCar: '加入购物车',
      textBuy: '立即购买',

      currentAddressInfo: {},
      ShopDetail: null,
      userId: "",
      chousetype: "",
      selectPrice: '',
      selectPriceUnit: '点', // 价格单位
      selectMarketprice: "",
      currentMarketPrice: null,
      currentSaveAmount: null,
      currentJdSkuCode: '',
      showPriceCompareRuleDialog: false,
      goodNum: 1, // 商品数量
      specId: this.$route.query.specId, // 规格 id
      showShopAddress: false,
      // sendSelectType: 0, //1 自提  2 快递 3 商户
      shipDate: "",
      shipTimeText: "",
      shopDetail: "",
      shopId: "",
      shopName: "",
      consigneeAddress: "",
      consigneeName: "",
      consigneePhone: "",
      addressId: "",
      productType: "", //0 票 1 蛋糕 2 其他
      delivery_amount: "0",
      addressList: [], // 地址信息list
      addressInfo: {
        address: "",
        consigneeAddress: "",
        consigneeName: "",
        consigneePhone: "",
        addressId: "",
      }, // 收货地址信息
      showAddCard: true,
    };
  },
  components: { DetailsSpecItem, DetaillNow, SelectAddress, SendType, ShopAddress, SpecPopup, OverlayLoad, PriceCompareBar, PriceCompareRuleDialog },

  mounted() {
    this.init();
    this.bannerHeight = (document.body.clientWidth || window.innerWidth || document.documentElement.clientWidth)
    var timer = setInterval(() => {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0
      clearInterval(timer);
    }, 200)
    // if (window.history && window.history.pushState) {
    //   // 向历史记录中插入了当前页
    //   history.pushState(null, null, document.URL);
    //   window.addEventListener('popstate', this.goBack, false);
    // }
  },

  // destroyed() {
  //   window.removeEventListener('popstate', this.goBack, false);
  // },
  methods: {
    goBack() {
      this.$router.back();
    },
    getTitleTag() {
      let Tag = undefined
      if (this.detail?.labelList) {
        this.detail?.labelList.forEach(element => {
          if (element.smallLabelType == '1') {
            Tag = element
          }
        });
      }
      return Tag
    },
    getTagList() {
      let Tag = []
      if (this.detail?.labelList) {
        this.detail?.labelList.forEach(element => {
          if (element.smallLabelType !== '1') {
            Tag.push(element)
          }
        });
      }
      return Tag
    },
    formNumber(val) {
      if (val) {
        return parseFloat(val).toFixed(2)
      } else return ''

    },
    formatSaveAmount(val) {
      if (val == null || val === '') return '0';
      const num = Number(val);
      if (Number.isNaN(num)) return val;
      return Number.isInteger(num) ? String(num) : num.toFixed(2).replace(/\.?0+$/, '');
    },
    handleProductList() {
      if (this.detail && this.detail.brandName) {
        goBrandProductList(this.detail.brandName);
      }
    },
    async init() {
      this.userId = localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem("userInfo")).id : "";
      this.detailform.cardId = localStorage.getItem("cardId");
      this.detailform.cityCode = localStorage.getItem("cityCode");
      this.detailform.productId = this.$route.query.id;
      this.detailform.brandId = this.$route.query.brandId;
      await this.getProductDetail();
    },

    // 获取地址列表数据
    async getAddress() {
      const addressItemRes = await this.setAddresInfo();
      this.$emit("loadAfter", { addressInfo: this.addressInfo, target: addressItemRes });
      this.handleSeleceAddressItem({ addressInfo: this.addressInfo, target: addressItemRes });
    },
    /**
     * 选择收货地址 change 回调
     */
    async handleSeleceAddressItem({ addressInfo, target }) {
      this.target = target
      // 无收货地址,依然获取配送规则
      // if (this.target) {
        const rulesPayload = {
            cityCode: this.detailform.cityCode,
            quantitys: 1,
            distributionRuleId: this.detail.distributionRuleId,
            specId: this.detail.specificationList[0].id,
        };
        if (target && target.id != null) {
          rulesPayload.addrId = String(target.id);
        }
        const distributionRules = await queryDistributionRules(
          rulesPayload,
          this.detailform.brandId
        );
        if (distributionRules) {
          this.cantBuy = false// 不能买和加入购物车
          // 根据商品的isShowPrice设置按钮文案：次数卡显示"立即兑换"，其他显示"立即购买"
          this.updateButtonText()
          this.isDistribution = distributionRules.isDistribution
          this.deliveryRules = distributionRules.deliveryRules;
          this.deliveryInfo = distributionRules.deliveryInfo;
          // this.sendSelectType = distributionRules.sendSelectType;
          this.shopInfo = distributionRules.shopInfo;
          this.validate_delivery_dates = distributionRules.validate_delivery_dates;
          this.handleSpecPopupAddressChange({ addressInfo: target, distributionRules })
        } else {
          this.isDistribution = null
          this.deliveryRules = [];
          this.deliveryInfo = [];
          // this.sendSelectType = 0;
          this.shopInfo = [];
          this.validate_delivery_dates = [];
          this.cantBuy = true// 不能买和加入购物车
          this.textCar = '不支持配送'
          this.textBuy = '不支持配送'
        // }
      }
    },

    /**
     * 设置选择城市配置信息，
     */
    async setAddresInfo(record) {
      if (record) {
        const { id, addressCname, addressQname, addressPname, address, recipient, recipientMobile, houseNum } = record;
        this.addressInfo.address = addressCname + addressQname + addressPname + address + houseNum;
        // this.address = addressCname + addressQname + addressPname + address + houseNum;
        this.addressInfo.consigneeAddress = addressPname + address + houseNum;
        this.addressInfo.consigneeName = recipient;
        this.addressInfo.consigneePhone = recipientMobile;
        this.addressInfo.addressId = id;
        return this.addressList.find((item) => item.id === id);
      } else {
        this.addressInfo.address = "暂无收货地址点击添加地址";
      }
    },
    copyJdSkuCode() {
      if (!this.currentJdSkuCode) return;
      const text = String(this.currentJdSkuCode);
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(() => {
          this.$Toast('已复制京东商品编码');
        }).catch(() => {
          this.fallbackCopyJdSkuCode(text);
        });
      } else {
        this.fallbackCopyJdSkuCode(text);
      }
    },
    fallbackCopyJdSkuCode(text) {
      const input = document.createElement('textarea');
      input.value = text;
      document.body.appendChild(input);
      input.select();
      try {
        document.execCommand('copy');
        this.$Toast('已复制京东商品编码');
      } catch (e) {
        this.$Toast('复制失败，请手动复制');
      }
      document.body.removeChild(input);
    },
    updatePriceCompareBySpec(specInfo_) {
      this.applyPriceCompareFromSpec(specInfo_);
    },
    applyPriceCompareFromSpec(specInfo_) {
      const marketPrice = specInfo_.marketPrice;
      const showPrice = specInfo_.showPrice;
      this.currentJdSkuCode = specInfo_.jdSkuCode || '';
      const hasJd = this.hasJdSkuCodeValue(this.currentJdSkuCode);
      if (
        hasJd
        && marketPrice != null
        && showPrice != null
        && Number(marketPrice) > Number(showPrice)
      ) {
        this.currentMarketPrice = marketPrice;
        this.currentSaveAmount = Number(marketPrice) - Number(showPrice);
      } else {
        this.currentMarketPrice = null;
        this.currentSaveAmount = null;
      }
    },
    hasJdSkuCodeValue(code) {
      return !!(code && String(code).trim());
    },
    openPriceCompareRule() {
      this.showPriceCompareRuleDialog = true;
    },
    // 获取商品详情
    async getProductDetail() {
      this.loading = true;
      const goodsData = await getGoodsDetail(this.detailform, this.specId);
      this.productDetaiLoad = true;
      if (goodsData) {
        this.detail = goodsData.target;
        this.productType = this.detail.productType
        if (this.detail.venueList && this.detail.venueList.length > 0) {
          this.detail.venueList[0].checked = true
        }
        this.specsLsit = goodsData.specsArr;
        this.setGoodsInfo(goodsData.defaultSpecs);
        this.getAddress()
      } else {
        var timer = setInterval(() => {
          this.$router.back();
          clearInterval(timer);
        }, 1000)

      }
      this.loading = false;
    },
    SelectShopAddress() {
      if (this.ShopDetail) {
        this.showShopAddress = true;
      }
    },
    // 去购物车
    goCar() {
      goMyCart(2);
    },
    /**
     * 打开规格选择内容页
     */
    specPopupOpen(params) {
      if (!this.showAddCard) {
        params = 'buyNow'
      }
      // 传递当前页面的按钮文本给规格选择弹窗
      const buttonTexts = {
        textBuy: this.textBuy,
        textCar: this.textCar
      };
      this.$refs.specPopupRef.open(params, buttonTexts);
    },
    /**
     * 规格菜单点击加入【购物车|立即购买】执行函数
     */
    async handleSpecSubmit({ type, selectedSpec, deliveryData }) {
      this.setGoodsInfo(selectedSpec, selectedSpec.count);
      // if (!this.address) {
      //   addressTag();
      //   return;
      // }
      this.loading = true;
      await submitBuyGoodsInfo(
        type,
        { userId: this.userId, ...this.detailform },
        deliveryData,
        selectedSpec,
        this.detail
      );
      this.loading = false;
    },

    /**
     * 规格选择后触发方法
     */
    handleSpecChange({ selectedSpec, count }) {
      this.setGoodsInfo(selectedSpec, count);
    },

    /**
     * 选择演出票
     * @param {} param0 
     */
    handleTicketChange({ selectedSpec, count }) {
      this.goodNum = count; // 购买数量
      this.specId = selectedSpec.skuId || "";
    },
    /**
     * 配送地址变更执行函数
     */
    handleSpecPopupAddressChange({ addressInfo, distributionRules }) {
      this.cantBuy = false// 不能买和加入购物车
      // 根据福利卡类型设置按钮文案：次数卡显示"立即兑换"，其他显示"立即购买"
      this.updateButtonText()
      // this.setAddressItem(addressInfo)
      this.setDeliveryRulesInfo(distributionRules)
    },
    setDeliveryRulesInfo(distributionRules) {
      if (!distributionRules) return;
      // const { sendSelectType, shopInfo, deliveryRules, deliveryInfo } = distributionRules;
      const { shopInfo, deliveryRules, deliveryInfo } = distributionRules;
      if (shopInfo) {
        this.shopId = shopInfo.shopId;
        this.shopName = shopInfo.shopName;
        this.shopDetail = shopInfo.shopDetail;
      }
      this.showAddCard = distributionRules.showAddcard
      this.sendTypeStr = deliveryInfo.sendTypeStr;
      this.shipDate = deliveryInfo.shipDate;
      this.shipTimeText = deliveryInfo.shipTimeText;
      this.delivery_amount = deliveryInfo.deliveryAmount;
      // this.sendSelectType = sendSelectType;
    },
    /**
     * 地址相关信息回填
     */
    setAddressItem(item) {

      this.currentAddressInfo = item;
      this.address = item.addressCname + item.addressQname + item.addressPname + item.address + item.houseNum;
      this.consigneeAddress = item.addressPname + item.address + item.houseNum;
      this.consigneeName = item.recipient;
      this.consigneePhone = item.recipientMobile;
      this.addressId = item.id;
    },
    /**
     * 商品相关的data数据回填
     * 从规格对象中获取后端已转换的价格、单位和显示标志
     */
    setGoodsInfo(specInfo, count = 1) {
      const specInfo_ = specInfo || {};
      const { id, specifications, showPrice, ticketPrice, bannerList, coverImage, htmEditorList, cardPointTypeUnit, isShowPrice, marketPrice, jdSkuCode } = specInfo_;
      this.goodNum = count; // 购买数量
      this.specId = id || "";
      if (this.productType === '0' && ticketPrice) {
        this.selectGoods = `${ticketPrice}`;
        this.chousetype = ticketPrice;
      } else {
        this.selectGoods = specifications ? `${specifications}` : "暂无商品";
        this.chousetype = specifications || "暂无商品";
      }

      // 使用后端返回的价格（已转换）和单位
      this.selectPrice = showPrice || "暂无价格";
      this.selectPriceUnit = cardPointTypeUnit || '点';
      
      // 如果商品detail对象中没有isShowPrice，从规格中获取
      if (this.detail && isShowPrice !== undefined) {
        this.detail.isShowPrice = isShowPrice;
      }

      this.updatePriceCompareBySpec({ marketPrice, showPrice, jdSkuCode });
      
      this.setBannerList(coverImage, bannerList, htmEditorList);
    },
    /**
     * 将规格图片推到banner图的主位上
     */
    setBannerList(specsImg, bannerList, htmEditorList) {
      // if (!specsImg) return;
      this.bannerList = Utils.isNoEmptyArr(bannerList) ? [specsImg, ...bannerList] : [specsImg];
      this.goodsDetailImgList = htmEditorList
    },
    /**
     * 根据商品的isShowPrice更新按钮文案
     * isShowPrice=false 表示次数卡商品，显示"立即兑换"
     */
    updateButtonText() {
      if (this.detail?.isShowPrice === false) {
        this.textBuy = '立即兑换';
        this.textCar = '加入购物车';
      } else {
        this.textBuy = '立即购买';
        this.textCar = '加入购物车';
      }
    }
  },
  // beforeRouteEnter(to, from, next) {
  //   console.log('  beforeRouteEnter   detail');
  //   next();

  // },
  // beforeRouteLeave(to, from, next) {

  //   console.log('  beforeRouteLeave  detail ',to.meta.refresh);
  //   next();
  // },

  computed: {
    /** 仅活动商品列表且为价格保护活动时展示京东编码/参考价等 */
    isPriceCompareActivity() {
      return String(this.$route.query.activityFeatureType) === '1';
    },
    hasJdPriceCompare() {
      return this.isPriceCompareActivity && this.hasJdSkuCodeValue(this.currentJdSkuCode);
    },
    showPriceCompareFloatBar() {
      return this.hasJdPriceCompare && this.detail?.isShowPrice !== false;
    },
    showPriceCompareDetail() {
      return this.hasJdPriceCompare
        && this.detail?.isShowPrice !== false
        && this.currentMarketPrice != null
        && this.currentSaveAmount != null
        && Number(this.currentSaveAmount) > 0;
    },
    // 净化后的 description，防止 XSS
    sanitizedDescription() {
      return sanitizeHtml(this.detail?.description || '');
    }
  }

};
</script>

<style lang="scss" scoped>
.details-page {
  background: #f8f8f8;
  overflow-x: hidden;
  min-height: 100vh;
  display: flex;
  flex-direction: column;

  .good {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding-bottom: 60px; // 为底部操作栏留出空间
  }

  .banner-section {
    width: 100%;
    height: 100vw;
    position: relative;
    background: #fff;
    flex-shrink: 0;
    
    .banner-swipe {
      width: 100%;
      height: 100%;
    }

    .banner-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .info-section {
    background: #fff;
    padding: 16px;
    margin-bottom: 8px;
    flex-shrink: 0;

    .price-section {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 12px;
      gap: 8px;

      .price {
        flex: 1;
        min-width: 0;

        .price-main-row {
          display: flex;
          flex-wrap: nowrap;
          align-items: baseline;
          line-height: 1.2;
          overflow: hidden;
          gap: 4px;
        }

        .price-value {
          font-size: 28px;
          font-weight: 600;
          color: #D23B2E;
          font-family: DIN;
          flex-shrink: 0;
        }

        .price-unit {
          font-size: 14px;
          color: #D23B2E;
          flex-shrink: 0;
        }

        .market-price {
          flex-shrink: 1;
          min-width: 0;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-left: 2px;
          font-size: 12px;
          color: #999;
          text-decoration: line-through;
        }

        .save-amount {
          flex-shrink: 0;
          margin-left: 4px;
          padding: 2px 6px;
          font-size: 11px;
          color: #ff7d00;
          font-weight: 600;
          white-space: nowrap;
          border-radius: 4px;
          background: rgba(255, 125, 0, 0.1);
        }
      }

      .title-tag {
        padding: 4px 8px;
        border-radius: 4px;
        color: #fff;
        font-size: 12px;
        font-weight: 500;
        flex-shrink: 0;
      }
    }

    .product-name {
      margin-bottom: 12px;
      line-height: 1.4;

      .name {
        font-size: 16px;
        font-weight: 600;
        color: #333;
      }
    }

    .tag-list {
      display: flex;
      flex-wrap: wrap;
      gap: 8px;

      .tag-item {
        padding: 4px 8px;
        background: #f5f5f5;
        border-radius: 4px;
        font-size: 12px;
        color: #666;
      }
    }

    .jd-sku-bar {
      display: flex;
      align-items: center;
      margin-top: 12px;
      padding: 8px 10px;
      min-height: 36px;
      border-radius: 8px;
      background: #fff5f4;
      border: 1px solid rgba(210, 59, 46, 0.1);
      box-sizing: border-box;

      .jd-sku-bar__label {
        display: inline-flex;
        align-items: center;
        flex-shrink: 0;
        height: 24px;
        padding: 0 8px 0 6px;
        border-radius: 4px;
        background: #d23b2e;
        color: #fff;
        font-size: 11px;
        font-weight: 600;
        line-height: 24px;
        white-space: nowrap;
        cursor: pointer;
      }

      .jd-sku-bar__shield {
        margin-right: 3px;
        font-size: 12px;
      }

      .jd-sku-bar__help {
        display: inline-flex;
        align-items: center;
        margin-left: 4px;
        padding: 0 4px;
        height: 14px;
        border-radius: 3px;
        background: rgba(255, 255, 255, 0.22);
        color: #fff;
        font-size: 10px;
        font-weight: 500;
        line-height: 14px;
        flex-shrink: 0;
      }

      .jd-sku-bar__actions {
        display: inline-flex;
        align-items: center;
        justify-content: flex-end;
        flex: 1;
        min-width: 0;
        margin-left: 10px;
        gap: 6px;
      }

      .jd-sku-bar__meta-label {
        flex-shrink: 0;
        font-size: 11px;
        color: #999;
      }

      .jd-sku-bar__code {
        flex: 1;
        min-width: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 12px;
        color: #666;
        font-weight: 500;
        font-family: DIN, monospace;
      }

      .jd-sku-bar__copy {
        flex-shrink: 0;
        padding: 2px 8px;
        font-size: 11px;
        color: #d23b2e;
        font-weight: 600;
        border-radius: 4px;
        background: rgba(210, 59, 46, 0.08);
        cursor: pointer;
        white-space: nowrap;
      }
    }
  }

  .spec-section {
    background: #fff;
    margin-bottom: 8px;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    flex-shrink: 0;

    .spec-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 18px 16px;
      border-bottom: 1px solid #f5f5f5;
      cursor: pointer;
      transition: all 0.2s ease;
      position: relative;

      &:first-child {
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
      }

      &:last-child {
        border-bottom: none;
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
      }

      &:hover {
        background-color: #fafafa;
      }

      &:active {
        background-color: #f0f0f0;
        transform: scale(0.98);
      }

      .spec-label {
        display: flex;
        align-items: center;
        min-width: 60px;

        .label-text {
          font-size: 15px;
          color: #333;
          font-weight: 500;
        }
      }

      .spec-content {
        display: flex;
        align-items: center;
        flex: 1;
        justify-content: flex-end;
        gap: 10px;

        .spec-text {
          font-size: 14px;
          color: #666;
          text-align: right;
          max-width: 180px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          line-height: 1.4;
        }
      }

      &::after {
        content: '';
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 3px;
        height: 16px;
        background: linear-gradient(135deg, #D23B2E, #FF6B5A);
        border-radius: 2px;
        opacity: 0;
        transition: opacity 0.2s ease;
      }

      &:hover::after {
        opacity: 0.6;
      }
    }
  }

  .detail-section {
    background: #fff;
    padding: 16px;
    flex: 1;

    .section-header {
      display: flex;
      align-items: center;
      margin-bottom: 16px;

      .header-text {
        font-size: 16px;
        font-weight: 600;
        color: #333;
      }
    }

    .description {
      font-size: 15px;
      color: #333;
      line-height: 1.7;
      margin-bottom: 20px;
      white-space: pre-wrap;
      word-break: break-word;

      :deep(p) {
        margin: 10px 0;
        font-size: 15px;
        line-height: 1.7;
        color: #333;
      }

      :deep(br) {
        content: "";
        display: block;
        margin: 8px 0;
      }

      :deep(img) {
        max-width: 100%;
        height: auto;
        margin: 10px 0;
        border-radius: 4px;
      }

      :deep(strong) {
        font-weight: 600;
        color: #222;
        font-size: 15px;
      }

      :deep(ul), :deep(ol) {
        padding-left: 20px;
        margin: 10px 0;
      }

      :deep(li) {
        margin: 5px 0;
        font-size: 15px;
        line-height: 1.7;
        color: #333;
      }
    }

    .image-list {
      font-size: 0; // 去掉内联元素间的空白
      .detail-image {
        width: 100%;
        margin: 0;
        border-radius: 0;
        display: block;
      }

      :deep(.van-image__img) {
        display: block;
      }
    }

  }
}

// 底部操作栏样式优化
:deep(.van-goods-action) {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
  
  .van-goods-action-button {
    height: 40px;
    font-size: 15px;
  }
}

.header-line {
  width: 3px;
  height: 16px;
  background: #D23B2E;
  margin-right: 8px;
  border-radius: 2px;
}
</style>

